import { render, staticRenderFns } from "./DownloadFileLink.vue?vue&type=template&id=3e188d38&scoped=true"
import script from "./DownloadFileLink.vue?vue&type=script&lang=js"
export * from "./DownloadFileLink.vue?vue&type=script&lang=js"
import style0 from "./DownloadFileLink.vue?vue&type=style&index=0&id=3e188d38&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e188d38",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/DownloadFileLink.vue
// module id = 1568
// module chunks = 31